import { withTransform } from '../../../Components/Globals/cloudinary';

// Shop card backdrop; photos that can't be cropped are padded in this color so every card matches
export const CARD_BACKDROP = '1A1B1E';

// Shop card image, always 4:3 and sized for the grid. Most photos are cropped around the piece to fill
// the card. Very wide or tall photos (long oblongs, vases) would lose part of the piece, so Cloudinary
// pads those whole on the card backdrop instead.
// f_auto also converts HEIC uploads to a format every browser can show.
export const cardImageUrl = (url) => withTransform(
    url,
    `if_ar_gt_1.8_or_ar_lt_0.9/c_pad,ar_4:3,b_rgb:${CARD_BACKDROP},w_700/if_else/c_fill,g_auto,ar_4:3,w_700/if_end/q_auto,f_auto`
);

// Item page: the whole photo, at most 1200px wide
export const detailImageUrl = (url) => withTransform(url, 'c_limit,w_1200,q_auto,f_auto');

// Item page thumbnails: small squares on the card backdrop, sharp at 64px on high-density screens
export const thumbImageUrl = (url) => withTransform(url, `c_pad,ar_1:1,b_rgb:${CARD_BACKDROP},w_160,q_auto,f_auto`);

// Full-screen viewer: large enough for big displays
export const fullImageUrl = (url) => withTransform(url, 'c_limit,w_2000,q_auto,f_auto');
